// removed by extract-text-webpack-plugin
module.exports = {"button-container":"doc-return__button-container___Pqan2"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/doc-return.scss
// module id = 1359
// module chunks = 0